// ./module/layers/SnapVectorLayer.js
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style'
import { Point } from 'ol/geom'

// 创建吸附可视化图层
export function createSnapVectorLayer() {
  return new VectorLayer({
    source: new VectorSource(),
    style: new Style({
      image: new CircleStyle({
        radius: 7,
        fill: new Fill({ color: 'rgba(255, 0, 0, 0.5)' }),
        stroke: new Stroke({ color: 'red', width: 2 }),
      }),
    }),
    zIndex: 9998, // 确保在最上层
  })
}

// 创建吸附点数据源（从tp_node_sql图层提取）
export function createSnapPointSource() {
  return new VectorSource()
}

// 创建吸附线数据源（从tp_pipeline_sql图层提取）
export function createSnapLineSource() {
  return new VectorSource()
}

// 创建吸附线折点数据源（存放线折点）
export function createSnapLineVertexSource() {
  return new VectorSource()
}
